<template>
    <div id="newsContainer">
        <div id="newsNav">
            <div id="newLeft">新闻中心</div>
            <div id="newRight">
                <i class="el-icon-s-home"></i>
                您当前位置：
                <router-link to="/" tag="span">首页 > </router-link>
                <router-link to="/news" tag="span">新闻中心</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Screen2',
}
</script>

<style scoped>
    #newsContainer{
        background: #edf0f5;   
    }
    #newsNav{
        width: 1090px;
        padding: 0 20px 0 10px;
        margin: 0 auto;
        background: #fff;
        color: #adadad;
        overflow: hidden;
        line-height: 40px;
    }
    #newLeft{
        font-size: 16px;
        float: left;
        border-bottom: 2px solid #1971d2;
    }
    #newRight{
        float: right;
        font-size: 16px;
    }
    #newRight>i{
        font-size: 18px;
    }
    #newRight>span{
        cursor: pointer;
        font-size: 16px;
    }
    #newRight>span:last-child{
        color: #467ed3;
    }
</style>
